<template>
	<div class="w-100" style="overflow-x:hidden;">
		<div class="row mt-3" v-if="!noToolbar">
			<div class="col-6 col-md-3 col-lg-3 my-2 text-left">
				<!-- Flexbox container to align items horizontally -->
				<div class="d-flex align-items-center">
				<!-- Select dropdown -->
					<select class="form-control form-control-sm custom-select" v-model="row" @change="refetch">
						<option value="10">10</option>
						<option value="20">20</option>
						<option value="50">50</option>
						<option value="100">100</option>
					</select>
				<!-- Export Options Dropdown -->
					<div style="margin-left:10px" v-if="!noToolbar && useXml">
						<b-dropdown :text="dropdownText" variant="primary" size="sm">
						<b-dropdown-item @click="selectExportType('invoice')">Export Invoice Barang</b-dropdown-item>
						<b-dropdown-item @click="selectExportType('invoice-airtime')">Export Invoice Airtime</b-dropdown-item>
						<b-dropdown-item @click="selectExportType('tax')">Export TAX</b-dropdown-item>
						</b-dropdown>
					</div>
					<div>
				<button class="btn btn-sm btn-success" @click="exportXml" style="width: 100px;">
					Apply Export
				</button>
				
			</div>
			<div v-if="showSearch" class="col-lg-12 text-right inline-block search">
						<div class="row justify-content-end">
							<div class="col-lg-12 float-right">
								<input class="form-control form-control-sm border border-light shadow-sm" type="text"
									placeholder="Search"
									v-model="searchValue" 
									@input="searching">
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<div class="row mb-3 mt-3" v-if="!noToolbar && useFilter">
			<b-card class="col-lg-12 bg-light mb-auto m-auto">
				<div class="row">
					<div class="col-lg-3">
						<b-form-datepicker today-button reset-button close-button
							v-model="filterObj.startDate"
							:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							id="datatable-datepicker1" class="border border-light shadow-sm" size="sm">
						</b-form-datepicker>
					</div>
					<div class="col-lg-3">
						<b-form-datepicker today-button reset-button close-button
							v-model="filterObj.endDate"
							:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							id="datatable-datepicker2" class="border border-light shadow-sm" size="sm">
						</b-form-datepicker>
					</div>
					<div type="button" title="search"
					     class="btn btn-primary btn-sm" @click="searching">Apply
					</div>
					
				</div>
			</b-card>
		</div>
		<!-- <div class="row mb-3 mt-3" v-if="!noToolbar && useFilter">
		<b-card class="col-lg-12 bg-light mb-auto m-auto">
			<div class="row">
				<div class="col-lg-3">
					<b-form-datepicker today-button reset-button close-button
						v-model="filterObj.startDate"
						id="datatable-datepicker1"
						class="border border-light shadow-sm" size="sm">
					</b-form-datepicker>
				</div>

				<div class="col-lg-3">
					<b-form-datepicker today-button reset-button close-button
						v-model="filterObj.endDate"
						id="datatable-datepicker2"
						class="border border-light shadow-sm" size="sm">
					</b-form-datepicker>
				</div>

				<div class="btn btn-primary btn-sm"
					@click="searching">Apply
				</div>
			</div>
		</b-card>
	</div> -->

		<div :class="[responsive?'table-responsive':'']">
			
			<table class="table p-2 shadow table-dark-custom"
					:class="[!$isMobile?'bg-white':'bg-transparent',!$isMobile?'':'border-0 border-none',noborder?'borderless':'']"
					:borderless="$isMobile" rules="cols">
				<tr class="default-row">
					<th v-for="(item,index) in structure" 
						v-bind:key="id+'tblhead'+index">
					{{ typeof item.label == "string" ? item.label : item.label[lang] }}
					</th>
					<slot name="head"></slot>
				</tr>
				<tr v-for="(item,index) in datas" 
					v-bind:key="id+'data'+index"
					v-show="(useSeeker && !seekerObj.isSeekingData) || (limiter(index) && checkValue(item,searchValue)) && !init">
					<slot name="customcell" v-bind:obj="item" v-bind:index="index">
					<td v-for="keyIdx in Object.keys(item).length" 
						v-bind:key="id+'defcol'+keyIdx"
						v-show="hasKey(Object.keys(item)[keyIdx-1])">
						<slot :name="setName(Object.keys(item)[keyIdx-1])" 
							v-bind:obj="item" 
							v-bind:index="index">
						{{ item[Object.keys(item)[keyIdx - 1]] }}
						</slot>
					</td>
					</slot>
					<slot name="addon" v-bind:idx="index"></slot>
				</tr>
				</table>

		</div>
		<div class="w-100 mb-2 text-secondary bg-white p-2 shadow"
		     v-if="datas.length==0 && (!init && !seekerObj.isSeekingData)">
			Tidak ada data tersedia.
		</div>
		<div class="w-100 mb-2 text-secondary bg-white p-2 shadow" v-if="init || seekerObj.isSeekingData">
			<div class="spinner-border" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			Tunggu sebentar
		</div>
		
		 <!-- Pagination -->
		<div class="w-100 my-3 text-right paginations" v-if="!hidePagination">
		<button class="btn btn-secondary btn-sm rounded-pill"
				v-on:click="$emit('change-page',false);$emit('change-url',prevUrl)" 
				v-if="prevUrl!=null">
			<small><i class="nc-icon nc-stre-left"></i></small>
		</button>
		<span class="text-secondary ml-2">
			{{ max == 0 ? "Index: " : "" }} {{ currentIdx }}
		</span>
		<button class="btn btn-secondary btn-sm rounded-pill"
				v-on:click="$emit('change-page',true);$emit('change-url',nextUrl)" 
				v-if="nextUrl!=null">
			<small><i class="nc-icon nc-stre-right"></i></small>
		</button>
		</div>
	</div>
</template>
<script>
import * as axios from "axios";

export default {
	props: {
		noborder: {
			type: Boolean,
			default: false
		},
		noToolbar: {
			type: Boolean,
			default: false
		},
		showSearch: {
			type: Boolean,
			default: true
		},
		datas: {
			type: Array,
			default: () => {
				return [];
			}
		},
		structure: {
			type: Array,
			default: () => {
				return [];
			}
		},
		limit: {
			type: Number,
			default: 10
		},
		useSeeker: {
			type: Boolean,
			default: false
		},
		nextUrl: {
			type: String,
			default: null
		},
		prevUrl: {
			type: String,
			default: null
		},
		seekerUrl: {
			type: String,
			default: ""
		},
		
		lang: {
			type: String,
			default: "id"
		},
		currentIdx: {
			type: Number,
			default: 1
		},
		responsive: {
			type: Boolean,
			default: false
		},
		useFilter: {
			type: Boolean,
			default: false
		},
		useXml: {
		 	type: Boolean,
		 	default: false
		},
		hidePagination: {
			type: Boolean,
			default: false
		},
		init: true
	},
	
	data() {
		return {
			
			dropdownText: "SELECT", // Default text for the dropdown
			xmlUrl: "",
			idx: 0,
			max: this.datas.length,
			id: "",
			seekerObj: {
				isSeekingData: false,
				isNextQueue: false
			},
			filterObj: {
				startDate: new Date(),
				endDate: new Date(),
			},
			row: 10,
			searchValue: "",
			
			
		};
	},
	created() {
		console.log("datatable generated");
		this.id = new Date().getTime();
	},
	methods: {
		selectExportType(type) {
			
			if (type === "invoice") {
				this.xmlUrl = "/api/xml/invoice";
				this.dropdownText = "Export Invoice Barang";
			} else if (type === "invoice-airtime") {
				this.xmlUrl = "/api/xml/invoice-airtime";
				this.dropdownText = "Export Invoice Airtime";
			} else if (type === "tax") {
				this.xmlUrl = "/api/xml/exportxmltax";
				this.dropdownText = "Export TAX";
			}
		},
		refetch() {
			console.log(this.row);
			this.$emit("refetch", this.row);
		},
		seeker() {
			this.currentIdx = 1;
			this.prevUrl = null;
			this.nextUrl = null;
			let objFilter = {};

			if (this.seekerObj.isSeekingData) {
				if (!this.seekerObj.isNextQueue) {
					setTimeout(() => {
						this.seekerObj.isNextQueue = true;
						this.seeker();
					}, 1000);
					return;
				}

				return;
			}

			this.seekerObj.isNextQueue = false;
			this.seekerObj.isSeekingData = true;

			if (this.filterObj.startDate != "") {
				objFilter["startDate"] = this.filterObj.startDate;
			}

			if (this.filterObj.endDate != "") {
				objFilter["endDate"] = this.filterObj.endDate;
			}

			if (this.searchValue != "") {
				objFilter["all"] = this.searchValue;
			}

			axios.post(
				this.$baseUrl + this.seekerUrl,
				objFilter,
				{
					"headers": {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				console.log(result.data);
				if (!this.seekerObj.nextQueue) {
					this.$emit("searching", {status: true, data: result.data});
					this.currentIdx = 1;
				}

				this.seekerObj.isSeekingData = false;
				this.seekerObj.isNextQueue = false;
				//console.log(result)
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}

				this.$emit("searching", {status: false, data: []});
				console.log(err);
				this.seekerObj.isSeekingData = false;
				this.seekerObj.isNextQueue = false;
			});
		},
		
		formatDate(date) {
			if (!date) return "";
			const d = new Date(date);
			return d.toISOString().slice(0, 10); 
		},

		exportXml() {
			let objFilter = {};

			if (!this.filterObj.startDate || !this.filterObj.endDate) {
				alert("Please select both start and end dates.");
				return;
			}

			objFilter["startDate"] = this.formatDate(this.filterObj.startDate);
			objFilter["endDate"] = this.formatDate(this.filterObj.endDate);

			if (this.filterObj.name && this.filterObj.name !== "undefined") {
				objFilter["name"] = this.filterObj.name;
			}

			let paramGet = '';
			for (let data in objFilter) {
				paramGet += (paramGet === '' ? '?' : '&') + data + '=' + encodeURIComponent(objFilter[data]);
			}

			let url = this.$baseUrl + this.xmlUrl + paramGet;

			window.open(url, "_blank");
		},

		//Logic for exporting Tax XML
		getXmltax() {
			let objFilter = {};
			// Validate whether startDate and endDate are selected
			if (this.filterObj.startDate === "" || this.filterObj.endDate === "") {
				alert("Please select both a start date and an end date for export.");
				return;
			}

			// startDate and endDate into the filter
			objFilter["startDate"] = this.filterObj.startDate;
			objFilter["endDate"] = this.filterObj.endDate;
			
			if (this.filterObj.name != "") {
				objFilter["name"] = this.filterObj.name;
			}

			if (Object.keys(objFilter).length === 0) {
				alert("Please select a start and end date for export.");
				return;
			}

			let paramGet = '';
			for (let data in objFilter) {
				if(paramGet == ''){
					paramGet = '?';
				} else {
					paramGet += '&';
				}
				paramGet += data+'='+encodeURIComponent(objFilter[data]);
			}

			let url = this.$baseUrl + this.xmlUrl + paramGet;

			// Use window.open() if the backend returns XML correctly
			window.open(url, "_blank");
		},
		checkValue(item, search) {
			if (search == "") {
				//console.log('true')
				return true;
			} else {
				let isOK = false;

				for (let x = 0; x < Object.keys(item).length; x++) {
					try {
						console.log(Object.keys(item)[x]);
						if (this.hasKey(Object.keys(item)[x])) {
							if (item[Object.keys(item)[x]].includes(search)) {
								isOK = true;
								break;
							}
						}
					} catch (err) {
						//console.log('skipping')
					}
				}

				return isOK;
			}
		},
		searching() {
			this.$reActivateAccess(this);

			if (this.searchValue == "" && this.filterObj.startDate == "" && this.filterObj.endDate == "") {
				this.$emit("searching", {status: false, data: []});
			} else {
				this.seeker();
			}
		},
		
		setName(key) {
			console.log(key);
			return key.toLowerCase();
		},
		limiter(curIdx) {
			return curIdx >= this.idx && curIdx < (this.idx + 10);
		},
		hasKey(keyName) {
			let contained = false;

			for (let x = 0; x < this.structure.length; x++) {
				if (this.structure[x].key == keyName) {
					contained = true;
					break;
				}
			}

			return contained;
		}
	}
};
</script>
<style scoped>
table {
	border: 1px solid #ddd;
}

table th, td {
	border: 1px solid #ddd;
}

@media screen and (min-width: 768px) {
	.default-row {
		display: table-row;
	}

	.default-cell {
		display: table-column;
	}

	.default-mobilecell {
		display: none;
	}

	.custom-select {
		width: 70%;
	}
}

@media screen and (max-width: 767px) {
	.default-row {
		display: none;
	}

	.default-cell {
		display: none;
	}

	.default-mobilecell {
		display: block;
	}

	.search button, input {
		width: 50%;
	}

	.custom-select {
		width: 50%;
	}

}

.paginations i {
	font-weight: bold;
}

.custom-select {
	width: 50%;
}
/* Optional: Customize flex container if needed */
.d-flex {
  display: flex;
  align-items: center; /* Vertically center the items */
}

.custom-select {
  width: auto; /* Let the select take its content width */
}

.b-dropdown {
  margin-left: 10px; /* Space between select and dropdown */
}

.table-dark-custom {
  /* background-color: #000 !important; */
  color: #fff !important;
}

.table-dark-custom th {
  background-color: #15085f !important;
  color: #fff !important;
}

.table-dark-custom td {
  /* background-color: #000 !important; */
  color: hsl(0, 4%, 5%) !important;
  /* border-color: #444;  */
}

</style>
